import Axios from "axios";
import React, { useState } from "react";
import { api_url } from "../../../config";
import Bouton from "../../common/HorsConnexion/Bouton";
import EcranResultat from "../../common/HorsConnexion/EcranResultat";
import { MESSAGE_SERVEUR_INDISPONIBLE, messageErreur } from "../../common/HorsConnexion/horsConnexion";
import Icone from "../../common/HorsConnexion/Icone";
import MessageEtat from "../../common/HorsConnexion/MessageEtat";
import PiedCarte from "../../common/HorsConnexion/PiedCarte";
import SaisieNir from "../../common/HorsConnexion/SaisieNir";
import "../../common/HorsConnexion/hors-connexion.scss";

/**
 * « Mot de passe oublié » : même appel qu'avant (POST auth/renew-password/app
 * avec le NIR). Deux usages : vue de la page de connexion, ou contenu du
 * dialogue du parcours RDSP (`inModal`, titre porté par le dialogue).
 * L'API répond de la même façon que le compte existe ou non : le message final
 * reste conditionnel.
 */
const ForgotPassword = ({ setForgotPassword = () => {}, nir = "", inModal = false }) => {
  const [login, setLogin] = useState(nir);
  const [erreurs, setErreurs] = useState({});
  const [envoi, setEnvoi] = useState(false);
  const [envoye, setEnvoye] = useState(false);

  function envoyer(e) {
    e.preventDefault();
    setEnvoi(true);
    setErreurs({});
    Axios.post(api_url + "auth/renew-password/app", { login: login })
      .then(() => {
        setEnvoye(true);
      })
      .catch((err) => {
        const donnees = err.response && err.response.data;
        if (donnees && donnees.login) setErreurs({ login: donnees.login });
        else setErreurs({ other: messageErreur(donnees) || MESSAGE_SERVEUR_INDISPONIBLE });
      })
      .then(() => setEnvoi(false));
  }

  const retour = () => setForgotPassword(false);

  if (envoye) {
    return (
      <div className={inModal ? "hc hc--dialogue" : undefined}>
        <EcranResultat ton="succes" icone="enveloppe" titre="Consultez votre boîte e-mail" niveau={inModal ? 2 : 1}>
          <p>
            Si votre compte est enregistré dans ESPOAR, un e-mail vient de vous être envoyé. Ouvrez-le
            et cliquez sur le lien qu'il contient pour choisir un nouveau mot de passe.
          </p>
          <p>Pensez à vérifier vos courriers indésirables.</p>
          {!inModal && (
            <Bouton secondaire onClick={retour}>
              Retour à la connexion
            </Bouton>
          )}
        </EcranResultat>
      </div>
    );
  }

  const formulaire = (
    <form onSubmit={envoyer} noValidate>
      <SaisieNir
        id="forgot-nir-inp"
        value={login}
        valeurInitiale={nir}
        onChange={(e) => {
          setLogin(e.target.value);
          setErreurs({});
        }}
        erreur={erreurs.login || null}
        autoFocus={!inModal}
      />
      {erreurs.other && (
        <MessageEtat ton="danger" icone="alerte">
          {erreurs.other}
        </MessageEtat>
      )}
      <Bouton type="submit" charge={envoi}>
        {envoi ? "Envoi en cours…" : "Recevoir le lien par e-mail"}
      </Bouton>
    </form>
  );

  if (inModal) {
    return (
      <div className="hc hc--dialogue">
        <p className="sous-titre">
          Indiquez votre numéro de sécurité sociale. Vous recevrez un e-mail avec un lien valable 24
          heures pour choisir un nouveau mot de passe.
        </p>
        {formulaire}
      </div>
    );
  }

  return (
    <section aria-labelledby="titre-oubli">
      <button type="button" className="lien retour" onClick={retour}>
        <Icone nom="chevronGauche" epaisseur={2.2} />
        Retour à la connexion
      </button>
      <h1 id="titre-oubli">Mot de passe oublié</h1>
      <p className="sous-titre">
        Indiquez votre numéro de sécurité sociale. Vous recevrez un e-mail avec un lien valable 24
        heures pour choisir un nouveau mot de passe.
      </p>
      {formulaire}
      <PiedCarte signature={false}>Le lien ne peut servir qu'une seule fois.</PiedCarte>
    </section>
  );
};

export default ForgotPassword;
